module.exports = __webpack_public_path__ + "static/media/data_results_logo.dc5ab1aa.png";